
import type { SeasonEnum } from '../../enums'
import { defineComponent } from 'vue'
import { ROUTER_CONSTS } from '../../router/router.consts'
import { DateUtils } from '../../utils/date.utils'
import { EpbButton } from '../shared/epb-button'
import LoginForm from './platform-login-form.component.vue'

export default defineComponent({
  name: 'PlatformLogin',
  components: {
    EpbButton,
    LoginForm,
  },
  data() {
    return {
      ROUTER_CONSTS,
      loginError: false,
    }
  },
  computed: {
    seasonImageUrl(): string {
      return require(`../../assets/media/image/seasons/${this.season}.webp`)
    },
    season(): SeasonEnum {
      return DateUtils.getSeason(new Date())
    },
  },
  methods: {
    onLogin(success: boolean) {
      if (!success) {
        this.loginError = true
      }
      this.$emit('login', success)
    },
  },
})
